import { toast } from "sonner";
import { api } from "../../../lib/api";

const VehiclesTab = ({
  vehicles,
  setSelectedVehicle,
  setShowKmModal,
  setKmLogs,
  setShowKmHistoryModal,
  setShowAccidentModal,
  setSelectedAccident,
  setShowDAAModal,
  darkMode
}) => {
  const handleViewKmHistory = async (vehicle) => {
    try {
      const res = await api.get(`/portal/vehicles/${vehicle.vehicle_id}/km-logs`);
      setKmLogs(res.data);
      setSelectedVehicle(vehicle);
      setShowKmHistoryModal(true);
    } catch (e) {
      toast.error('Erro ao carregar registos');
    }
  };

  return (
    <div>
      <h3 className={`text-xl font-bold mb-6 ${darkMode ? 'text-white' : 'text-slate-800'}`}>Viaturas Atribuídas</h3>
      
      {vehicles.length === 0 ? (
        <p className={`text-center py-8 ${darkMode ? 'text-slate-400' : 'text-slate-500'}`}>Sem viaturas atribuídas</p>
      ) : (
        <div className="grid md:grid-cols-2 gap-4">
          {vehicles.map((vehicle, idx) => (
            <div key={idx} className={`p-4 rounded-lg ${darkMode ? 'bg-slate-700/50' : 'bg-slate-100'}`}>
              <div className="flex items-center gap-3 mb-2">
                <span className="text-3xl">🚗</span>
                <div>
                  <p className={`font-medium ${darkMode ? 'text-white' : 'text-slate-800'}`}>{vehicle.brand} {vehicle.model}</p>
                  <p className="text-lg font-mono font-bold text-blue-400">{vehicle.license_plate}</p>
                </div>
              </div>
              <p className={`text-sm ${darkMode ? 'text-slate-400' : 'text-slate-500'}`}>
                Km atual: {vehicle.current_km?.toLocaleString('pt-PT')} km
              </p>
              
              {/* Accidents info */}
              {vehicle.accidents && vehicle.accidents.length > 0 && (
                <div className="mt-2 p-2 bg-red-900/30 rounded-lg">
                  <p className="text-sm text-red-300">⚠️ {vehicle.accidents.length} sinistro(s) registado(s)</p>
                </div>
              )}
              
              <div className="flex flex-wrap gap-2 mt-3">
                <button
                  onClick={() => { setSelectedVehicle(vehicle); setShowKmModal(true); }}
                  className="flex-1 px-3 py-2 rounded-lg bg-emerald-600 text-white text-sm hover:bg-emerald-500 transition-colors"
                  data-testid={`register-km-${vehicle.vehicle_id}`}
                >
                  📍 Registar KM
                </button>
                <button
                  onClick={() => handleViewKmHistory(vehicle)}
                  className={`flex-1 px-3 py-2 rounded-lg text-white text-sm transition-colors ${
                    darkMode ? 'bg-slate-600 hover:bg-slate-500' : 'bg-slate-500 hover:bg-slate-400'
                  }`}
                  data-testid={`view-km-history-${vehicle.vehicle_id}`}
                >
                  📋 Ver Histórico
                </button>
                <button
                  onClick={() => { setSelectedVehicle(vehicle); setShowAccidentModal(true); }}
                  className="flex-1 px-3 py-2 rounded-lg bg-red-600 text-white text-sm hover:bg-red-500 transition-colors"
                  data-testid={`register-accident-${vehicle.vehicle_id}`}
                >
                  🚨 Registar Sinistro
                </button>
              </div>
              
              {/* Show accidents for this vehicle */}
              {vehicle.accidents && vehicle.accidents.length > 0 && (
                <div className="mt-4 space-y-2">
                  <h4 className={`text-sm font-semibold ${darkMode ? 'text-white' : 'text-slate-800'}`}>Sinistros:</h4>
                  {vehicle.accidents.map((acc, accIdx) => (
                    <div key={accIdx} className={`p-3 rounded-lg ${darkMode ? 'bg-slate-800/50' : 'bg-slate-200'}`}>
                      <div className="flex justify-between items-start">
                        <div>
                          <p className={`text-sm ${darkMode ? 'text-white' : 'text-slate-800'}`}>{acc.date} - {acc.location}</p>
                          <p className={`text-xs ${darkMode ? 'text-slate-400' : 'text-slate-500'}`}>{acc.description}</p>
                        </div>
                        <span className={`px-2 py-1 text-xs rounded-full ${
                          acc.status === 'daa_submitted' ? 'bg-green-100 text-green-700' :
                          acc.status === 'pending' ? 'bg-amber-100 text-amber-700' :
                          'bg-slate-100 text-slate-700'
                        }`}>
                          {acc.status === 'daa_submitted' ? 'DAA Enviada' : acc.status === 'pending' ? 'Pendente' : acc.status}
                        </span>
                      </div>
                      {acc.status !== 'daa_submitted' && (
                        <button
                          onClick={() => { setSelectedVehicle(vehicle); setSelectedAccident(acc); setShowDAAModal(true); }}
                          className="mt-2 px-3 py-1 text-xs rounded-lg bg-blue-600 text-white hover:bg-blue-500"
                        >
                          📄 Carregar DAA
                        </button>
                      )}
                    </div>
                  ))}
                </div>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default VehiclesTab;
